import { SET_SIDE_PANEL } from '../../mutation-types';
import * as actions from './actions';

const mutations = {
    [SET_SIDE_PANEL](state, { isOpen }) {
        state.isOpen = isOpen;
    },
};


const state = {
    isOpen: false,
};


export default {
    namespaced: true,
    mutations,
    actions,
    state,
};
